import React from 'react';
import { Input, Space, Switch } from 'antd';
import styles from '../../../event-timeline.module.css';

const { TextArea } = Input;

interface DisplayTextParamsProps {
  params: any;
  setParams: (params: any) => void;
}

const ShowModalParams: React.FC<DisplayTextParamsProps> = ({
  params,
  setParams,
}) => {
  return (
    <div className={styles.parameterContainer}>
      <Space direction='vertical' style={{ width: '100%' }}>
        <span>Title:</span>
        <Input
          value={params.title || ''}
          onChange={(e) => setParams({ ...params, title: e.target.value })}
          placeholder='Enter text to display'
        />
        <span>Text:</span>
        <TextArea
          value={params.text || ''}
          onChange={(e) => setParams({ ...params, text: e.target.value })}
          placeholder='Enter text to display'
          rows={4}
        />
        <div>
          <h3>Show Model Preview:</h3>
          <Switch
            value={params.showModelPreview || ''}
            onChange={(value) =>
              setParams({ ...params, showModelPreview: value })
            }
          />
        </div>
      </Space>
    </div>
  );
};

export default ShowModalParams;
